<template>
  <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modalcito">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"><b>Asignar plataforma al programa</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <p>Seleccione una plataforma moodle para este programa</p>
          <select v-model="plataforma" class="form-control">
            <option :key="ind" v-for="(p, ind) in plataformas" :value="p.id">{{ p.nombre }} - {{ p.direccion }}</option>
          </select>
        </div>

        <Alertas ref="alertar" v-bind:msgSuccess="'La asignacion de plataforma se realizo satisfactoriamente.'" v-bind:msgLoading="'Aplicando...'" />
        <p class="text-center">{{ msg }}</p>
        <div class="modal-footer">
          <button @click="submit" :disabled="!activo" type="button" class="btn btn-azul">Aceptar</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue';
import gql from 'graphql-tag';
import { parseJsonError } from '@/components/Utils.js';
import { mapState } from 'vuex';

export default {
  props: {
    obj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activo: true,
      msg: '',
      plataforma: -1,
      plataformas: [],
    };
  },
  watch: {
    'obj.xid': function () {
      if (this.obj.xid == null) return;
      this.$refs.alertar.reset();
      this.activo = true;
    },
    obj: function () {
      this.$refs.alertar.reset();
      this.activo = true;
    },
    UNIDAD_NEGOCIO_ID() {
      this.getDatos();
    },
  },

  components: { Alertas },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      datos: (state) => {
        if (state.UNIDAD_NEGOCIO_ID) {
          return state.plataforma.items.filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID);
        }
        return [];
      },
    }),
  },
  methods: {
    hidden() {
      this.$refs.alertar.cargando();
    },
    getDatos() {
      const qs = gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`;

      this.$apollo
        .query({ query: qs })
        .then(({ data }) => {
          this.plataformas = data.getPlataformas;
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getPrograma'));
        });
    },
    submit() {
      // window.console.log(this.obj, this.plataforma);
      if (this.plataforma == -1) {
        this.msg = 'No ha seleccionado ninguna plataforma';
        return;
      }
      this.$refs.alertar.cargando();
      var sql = gql`mutation{ asignarPlataforma(input:{ programa_id:${this.obj.xid}, plataforma_id: ${this.plataforma} }){ok errors{message} programa{id}} }`;
      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          var res = data.data.asignarPlataforma;
          if (res.ok) {
            this.$refs.alertar.success('Asignado');
            this.activo = false;
          } else {
            this.activo = true;
            var errores = JSON.stringify(data.data.asignarPlataforma.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            //vue.msg = vals;
            this.$refs.alertar.invalido(vals);
          }
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getPrograma'));
        });
    },
  },
  mounted() {
    var vue = this;
    window.$('#plataformasig').on('hidden.bs.modal', function () {
      vue.msg = '';
      //vue.programa = {}
      vue.activo = true;
      vue.$refs.alertar.reset();
    });
    this.getDatos();
  },
};
</script>